module.exports = __webpack_public_path__ + "img/UK.98a4e789.png";